import DataProvider from "~/data-provider";
import { addListener, removeListener } from "~/lib/signals";

export default class DataProviderCadastral extends DataProvider {
	_changeWidthSignal: string;

	constructor() {
		super();
		this._changeWidthSignal = "";
	}

	isActive() {
		return this._active;
	}

	enable() {
		if (this._active) {
			return null;
		}

		this._changeWidthSignal = addListener({}, "width-change", () => {
			const geometries = this._layers[0].getFilters()?.geometry?.[0]?.layer?.getGeometries();

			for (const id in geometries) {
				if (geometries[id]) {
					const geometry = geometries[id];

					geometry.setPath([geometry.getPath()]);
				}
			}
		});


		return super.enable();
	}

	disable() {
		if (!this._active) {
			return null;
		}

		this._changeWidthSignal && removeListener(this._changeWidthSignal);

		this._changeWidthSignal = "";

		return super.disable();
	}
}
